module.exports = __webpack_public_path__ + "img/Alterna_120X35.127df459.png";